import React from 'react'
import { Button, Stack, Typography } from '@mui/material'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import VisibilityIcon from '@mui/icons-material/Visibility'
import Callout from '../../Common/callout/Callout'
import { NetworkCalloutProps } from './_props'
import { calloutStyles } from './_utils'
import sxs from './_sxs'
import { useFormContextUser } from '../../User/utils/_utils'

const NetworkCallout: React.FC<NetworkCalloutProps> = ({ text }) => {
    const [showPassword, setShowPassword] = React.useState(false)
    const { watch } = useFormContextUser()
    const watched = {
        password: watch('password'),
        realEmail: watch('realEmail'),
    }
    const variant = watched.realEmail === false ? 'WARNING' : 'INFO'

    const handleTogglePassword = () => {
        setShowPassword((previous) => !previous)
    }
    const calloutVariantStyle = calloutStyles[variant]

    const calloutText =
        variant === 'WARNING'
            ? "Après enregistrement, l’identifiant et le mot de passe provisoire ne pourront pas être envoyés par courriel, veuillez les transmettre à l'utilisateur"
            : text

    return (
        <Callout
            color={calloutVariantStyle.color}
            icon={calloutVariantStyle.icon}
            backgroundColor={calloutVariantStyle.background}
            border={false}
        >
            <Stack flexDirection="row" alignItems="center" gap="1.5rem">
                <Typography sx={{ ...sxs.networkCalloutTextBase, color: calloutVariantStyle.color }}>
                    {calloutText}
                </Typography>
                <Stack alignItems="center">
                    {variant === 'WARNING' && (
                        <Button
                            sx={{
                                ...sxs.networkCalloutButtonBase,
                                backgroundColor: calloutVariantStyle.color,
                                '&:hover': {
                                    backgroundColor: calloutVariantStyle.color,
                                    opacity: 0.75,
                                },
                            }}
                            startIcon={showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            onClick={handleTogglePassword}
                        >
                            {showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                        </Button>
                    )}
                    {variant === 'WARNING' && showPassword && (
                        <Typography sx={sxs.networkCalloutTextBase}>{watched.password}</Typography>
                    )}
                </Stack>
            </Stack>
        </Callout>
    )
}
export default NetworkCallout
